import {makeStyles} from "@material-ui/core/styles";
import {colors} from '../../shared/colors'

const useStyles = makeStyles( theme => ({

    footerPrimary: {
        background: colors.californiaBlue,
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'underline',
        padding: '2rem 0 0 1.5rem'
    },
    footerSecondary: {
        background: colors.magellan80Black,
        borderTop: `1px solid ${colors.magellan60Black}`
    },
    primaryTopLink1:{
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px',
        minHeight: '24px',
        '&:hover':{
            color: colors.californiaYellow
        }
    },
    primaryTopLink2:{
        color: 'white',
        fontSize: '14px',
        fontWeight: 500,
        paddingTop: '1rem',
        '&:hover':{
            color: colors.californiaYellow
        }
    },
    langLinks: {
        color: 'white',
        fontSize: '14px',
        fontWeight: 500,
        '&:hover':{
            color: colors.californiaYellow
        }
    },
    langLinksWrapper: {
        paddingTop: '3rem'
    },
    footerBottomLinks:{
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        '&:hover':{
            color: colors.californiaYellow,
            textDecoration: 'underline'
        }
    },
    bottomLinkWrapper: {
        padding: '0.7rem'
    }
}));

export default useStyles;